export default __webpack_public_path__ + "static/media/ggle.d905541c.jpg";